import React, { useEffect, useState } from "react";
import assets from "../../../../../assets/assets";
import styled from "styled-components";
import axios from "axios";
import { apiURL, distributionUrl } from "../../../../Config/url";
import { useAxiosConfigGlobal, EmailHeader } from "../../../../Config/axios";
import {
  IconController,
  ImgController,
  LottieController,
} from "../../../../Scripts/ImgController";
import Ripples from "react-ripples";
import HttpConfirmation from "../../HttpConfirmation";
import dummyCover from "../../../../../assets/images/sm-user.jpg";
import { useCookies } from "react-cookie";

const Wrapper = styled.div`
  .input-field {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 6px 8px;
  }
  .input-wrapper {
    width: 450px;
  }
  @media (max-width: 767px) {
    .input-wrapper {
      width: 100%;
    }
  }
`;

const NameSection = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const PublisherInformation = JSON.parse(
    localStorage.getItem("Current-Publisher")
  );
  const [previewImage, setPreviewImage] = useState(
    PublisherInformation?.cover || ""
  );
  const [newCoverData, setNewCoverData] = useState(null);

  const [emailData, setEmailData] = useState(EmailHeader);
  const [editable, setEditable] = useState(false);
  const [nameChange, setNameChange] = useState("");
  const [requestSent, setRequestSent] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const axiosConfig = useAxiosConfigGlobal();
  const [cookie] = useCookies();

  const [confirmation, setConfirmation] = useState(false);

  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const formData = new FormData();
  //     formData.append("image", file, "jpeg");

  //     setUploadingImage(true);

  //     try {
  //       const res = await axios.post(
  //         distributionUrl + "media/panel/images",
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //             Accept: "application/json",
  //             Authorization: "Bearer " + cookie.mmusic_token,
  //             "Publisher-Id": JSON.parse(
  //               localStorage.getItem("Current-Publisher")
  //             )?.id,
  //           },
  //         }
  //       );
  //       const uploadedURL = res.data?.url;

  //       setNewCoverData(uploadedURL);
  //       setPreviewImage(uploadedURL);
  //     } catch (err) {
  //       console.error("Upload error", err);
  //     } finally {
  //       setUploadingImage(false);
  //     }
  //   }
  // };

  const prepareConfirmation = () => {
    const attributesToConfirm = [];

    if (nameChange && nameChange !== PublisherInformation?.name) {
      attributesToConfirm.push({
        field: "Нийтлэгчийн нэр",
        value: {
          old: PublisherInformation?.name,
          new: nameChange,
        },
      });
    }

    if (newCoverData && newCoverData !== PublisherInformation?.cover) {
      attributesToConfirm.push({
        field: "Зураг",
        value: {
          old: PublisherInformation?.cover,
          new: newCoverData,
        },
      });
    }

    if (attributesToConfirm.length > 0) {
      setEmailData({ ...emailData, attributes: attributesToConfirm });
      setConfirmation(true);
    } else {
      setCKPopupType("Info");
      setCKPopupMessage("nothingChanged");
      setCKPopup(true);
    }
  };
  useEffect(() => {
    if (!editable) {
      setPreviewImage(PublisherInformation?.cover || "");
      setNewCoverData(null);
      setNameChange("");
    }
  }, [editable, PublisherInformation?.cover]);

  const requestHandler = async () => {
    setRequestSent(true);

    if (emailData.attributes.length === 0) {
      setCKPopupType("Info");
      setCKPopupMessage("nothingChanged");
      setCKPopup(true);
      return;
    }

    await axios
      .post(apiURL + "notifications/panel/emails", emailData, axiosConfig)
      .then((res) => {
        if (res.status === 200) {
          setEditable(false);
          setEmailData({ ...emailData, attributes: [] });
          setCKPopupType("Success");
          setCKPopupMessage("changeRequestSuccess");
          setCKPopup(true);
          setRequestSent(false);
          setNameChange("");
          setNewCoverData(null);
        }
      })
      .catch((err) => {
        setRequestSent(false);
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  };

  return (
    <Wrapper className="border-CK flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-0">
      {editable ? (
        <>
          {requestSent ? (
            <div
              className="absolute top-0 left-0 w-full h-full rounded-xl"
              style={{ background: "#a9b7d280" }}
            >
              <div className="w-full h-full flex flex-row justify-center items-center">
                <LottieController
                  src={assets.lottie.loadingLottie}
                  className="w-32 h-32 flex flex-row justify-center"
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className={`artist-image relative ${
              requestSent || uploadingImage ? "opacity-50" : ""
            }`}
          >
            {/* eniig dra n solih bolnoo */}
            <ImgController
              src={previewImage || dummyCover}
              className="w-24 h-24"
              imgClassName="rounded-full object-cover"
            />
            {/* eniig bas */}
            {/* <label className="cursor-pointer relative block w-24 h-24 group">
              <ImgController
                src={previewImage || dummyCover}
                className="w-24 h-24"
                imgClassName="rounded-full object-cover"
              />

              <input
                type="file"
                accept="image/*"
                className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                // onChange={handleFileChange}
              />

              <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 rounded-full flex items-center justify-center text-white text-xs">
                Зураг солих
              </div>

              {uploadingImage && (
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-full">
                  <LottieController
                    src={assets.lottie.loadingLottie}
                    className="w-16 h-16"
                  />
                </div>
              )}
            </label> */}
          </div>

          <div className="flex flex-col gap-4 sm:pl-3 input-wrapper sm:pt-8">
            <input
              type="text"
              className="input-field text-base"
              placeholder={PublisherInformation?.name}
              onChange={(value) => {
                setNameChange(value.target.value);
              }}
            />
          </div>
          {requestSent ? (
            ""
          ) : (
            <div className="absolute top-4 right-4 ">
              <div className="flex flex-row gap-2">
                <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                  <div
                    className="cancel-button"
                    onClick={() => {
                      setEditable(false);
                      setPreviewImage(PublisherInformation?.cover || "");
                      setNewCoverData(null);
                      setNameChange("");
                    }}
                  >
                    <div className="flex flex-row justify-center items-center px-3">
                      <h5 className="text-xs font-medium py-2 pr-1">Болих</h5>
                      <IconController
                        src={assets.svg.informationCancel}
                        className="h-4 w-4"
                      />
                    </div>
                  </div>
                </Ripples>
                <Ripples color="#ffffff40" during={600} className="rounded-2xl">
                  <div className="confirm-button" onClick={prepareConfirmation}>
                    <div className="flex flex-row justify-center items-center px-3">
                      <h5 className="text-xs font-medium py-2 pr-1">
                        Өөрчлөх хүсэлт илгээх
                      </h5>
                      <IconController
                        src={assets.svg.requestMail}
                        className="h-4 w-4"
                      />
                    </div>
                  </div>
                </Ripples>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="artist-image">
            {PublisherInformation?.cover === "" ||
            PublisherInformation?.cover === null ? (
              <img src={dummyCover} alt="" className="rounded-full" />
            ) : (
              <ImgController
                src={PublisherInformation?.cover}
                className="w-24 h-24"
                imgClassName="rounded-full"
              />
            )}
          </div>
          <div className="flex flex-col gap-2 sm:gap-4 sm:pl-3">
            <h5 className="text-base font-medium color-1 break-words">
              {PublisherInformation?.name}
            </h5>

            <h5 className="text-xs">
              {PublisherInformation?.type === "label"
                ? "Байгууллага"
                : "Уран бүтээлч"}
            </h5>
          </div>
          {isUserCanEdit ? (
            <div className="edit-button">
              <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    setEditable(true);
                    setNewCoverData(null);
                    setNameChange("");
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">Засах</h5>
                  <IconController
                    src={assets.svg.editIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
          ) : (
            ""
          )}
        </>
      )}
      {confirmation && (
        <HttpConfirmation
          yesFunc={requestHandler}
          data={emailData}
          noFunc={() => setConfirmation(false)}
        />
      )}
    </Wrapper>
  );
};

export default NameSection;
